<template>
  <div v-if="header.value === 'last_used_at'">
    <span v-if="item.last_used_at === null" class="text--disabled font-italic">{{
      $t("general.never")
    }}</span>
    <v-tooltip v-else open-delay="150" close-delay="150" offset-y bottom>
      <template v-slot:activator="{ on, attrs }">
        <span
          v-bind="attrs"
          v-on="on"
          class="mb-0 text-right gray--text text--darken-1"
        >
          {{ moment(item.last_used_at).fromNow() }}
        </span>
      </template>
      <span>{{ moment(item.last_used_at).format("YYYY-MM-DD HH:mm") }}</span>
    </v-tooltip>
  </div>
  <div v-else-if="header.value === 'created_at'">
    <v-tooltip open-delay="150" close-delay="150" offset-y bottom>
      <template v-slot:activator="{ on, attrs }">
        <span
          v-bind="attrs"
          v-on="on"
          class="mb-0 text-right gray--text text--darken-1"
        >
          {{ moment(item.created_at).fromNow() }}
        </span>
      </template>
      <span>{{ moment(item.created_at).format("YYYY-MM-DD HH:mm") }}</span>
    </v-tooltip>
  </div>
  <div
    v-else-if="header.value === 'actions'"
    :class="isMobile ? '' : 'actions-row'"
  >
    <v-tooltip
      transition="custom-tooltip"
      open-delay="150"
      bottom
      z-index="99"
      offset-overflow
      nudge-bottom="4px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-on="on"
          v-bind="attrs"
          icon
          small
          @click="$emit('action-button-delete', item)"
        >
          <v-icon>$thrash</v-icon>
        </v-btn>
      </template>

      <span>{{ $t("reseller.apiTokens.delete") }}</span>
    </v-tooltip>
  </div>
  <div v-else>
    {{ item[header.value] }}
  </div>
</template>

<script>
import moment from 'moment';

export default {
  components: {
  },
  props: {
    item: Object,
    header: Object,
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      moment,
    };
  },
  created() {},
  mounted() {},
  methods: {},
  watch: {},
  computed: {},
};
</script>
